import { render, staticRenderFns } from "./StaffService.vue?vue&type=template&id=b55cd68e&"
import script from "./StaffService.vue?vue&type=script&lang=js&"
export * from "./StaffService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports